// REACT
import React from "react";
// MATERIAL-UI
import { LinearProgress, Typography } from "@mui/material";
// ASSETS
import { MarketHeaderStyles } from "./styles";
import { formatCurrency } from "src/utils/helpers/PriceAndUnitsHelpers";
import { useGetMarketDataQuery } from "src/store/features/api/generated";
import { MarketUpdateMobileSkelton, MarketUpdateSkelton } from "src/components/common/Skeletons";

const HeaderBreakdown = () => {
  const { data: marketUpdate = { value: 0, change: 0 }, isSuccess } = useGetMarketDataQuery(
    undefined,
    {
      pollingInterval: 60000,
    },
  );
  const classes = MarketHeaderStyles();

  const desktopMessage1 = `The total crypto market cap is ${formatCurrency(
    marketUpdate.value,
    "USD",
    { type: "name" },
  )}`;

  const change = marketUpdate.change.toString().slice(0, 4);
  const desktopMessage2 = " from the previous day.";
  const increaseOf = ", an increase of ";
  const decreaseOf = ", a decrease of ";

  if (isSuccess) {
    return (
      <Typography className={classes.cryptoUpdate}>
        <span translate="no">{desktopMessage1}</span>
        {marketUpdate.change > 0 && (
          <>
            <span>{increaseOf}</span>
            <span className={classes.gains} translate="no">
              +{change ?? <LinearProgress />}%
            </span>
          </>
        )}
        {!(marketUpdate.change > 0) && (
          <>
            <span>{decreaseOf}</span>
            <span className={classes.loses} translate="no">
              {change}%
            </span>
          </>
        )}
        <span>{desktopMessage2}</span>
      </Typography>
    );
  } else {
    return (
      <>
        <MarketUpdateSkelton />
        <MarketUpdateMobileSkelton />
      </>
    );
  }
};

export default HeaderBreakdown;
